import type { FutureEditResult, VisitChanges } from '@/hooks/useRecurringSeries';

/** The job dialog's "Edit Job" form. */
export interface JobEditForm {
  title: string;
  client_name: string;
  client_email: string;
  client_phone: string;
  address: string;
  scheduled_date: string;
  start_time: string;
  end_time: string;
  service_id: string;
}

/** Edit-form values → update_recurring_series_from_visit changes. */
export function visitChangesFromForm(form: JobEditForm): VisitChanges {
  return {
    title: form.title,
    client_name: form.client_name,
    client_email: form.client_email,
    client_phone: form.client_phone,
    address: form.address,
    service_id: form.service_id,
    scheduled_date: form.scheduled_date,
    start_time: form.start_time,
    end_time: form.end_time,
  };
}

/** Friendly toast copy after "this and all future visits". */
export function futureEditSummary(result: Partial<FutureEditResult> | null | undefined): string {
  const created = result?.created ?? 0;
  const kept = result?.kept ?? 0;
  const parts = [`${created} upcoming ${created === 1 ? 'visit' : 'visits'} now follow the new pattern.`];
  if (kept > 0) parts.push(`${kept} you’d already changed or finished ${kept === 1 ? 'was' : 'were'} left as ${kept === 1 ? 'it was' : 'they were'}.`);
  return parts.join(' ');
}

/** Readable message from a Supabase/RPC error. */
export const errorText = (error: unknown, fallback = 'Please try again.') => {
  if (error instanceof Error && error.message) return error.message;
  if (error && typeof error === 'object' && typeof (error as { message?: unknown }).message === 'string') {
    return (error as { message: string }).message;
  }
  return fallback;
};
